import React from 'react';
import { BLOC_COMPONENTS } from './bloc-components';

export default function DynamicBlockRenderer({ block, sessionId, sequenceIndex, onSave, onRefresh, isEditable = false, isRTL = false, openRegenerateDialogForBlock = null, onRegenerateDialogOpened = null }) {
  // Get component for this block type (use type_bloc from API)
  const blockType = block.type_bloc || block.type;
  const BlockComponent = BLOC_COMPONENTS[blockType];
  
  // Handle unknown block types
  if (!BlockComponent) {
    console.error(`Unknown block type: ${blockType}`);
    return (
      <div style={{ 
        padding: '16px', 
        backgroundColor: '#fef2f2', 
        border: '1px solid #fecaca', 
        borderRadius: '8px',
        margin: '8px 0'
      }}>
        <p style={{ color: '#dc2626', fontWeight: 'bold', margin: '0 0 8px 0' }}>
          ⚠️ Unknown block type: {blockType}
        </p>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
          This block type is not registered in the frontend. 
          Please check the BLOC_COMPONENTS registry.
        </p>
      </div>
    );
  }
  
  // Render the appropriate component
  return (
    <BlockComponent 
      block={block}
      sessionId={sessionId}
      sequenceIndex={sequenceIndex}
      onSave={onSave}
      onRefresh={onRefresh}
      isEditable={isEditable}
      isRTL={isRTL}
      sequence={block.sequence}
      openRegenerateDialogForBlock={openRegenerateDialogForBlock}
      onRegenerateDialogOpened={onRegenerateDialogOpened}
    />
  );
}
